import constants from "../Utils/constants";
const initialState = {
  isjourneyRouteloading: false,
  allJourneyRoute: [],
  journeyRoute: {},
  setjourneyRouteId: "",
  isjourneyByIdLoading: false,
  isUpdatejourneyLoading: false,
  isCreatejourneyLoading: false,
  journeyError: "",
  isUpdateUserjourneyLoading: false,
};
export const journeyRouteReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_JOURNEY_ROUTE_REQUEST:
      return {
        ...state,
        isjourneyRouteloading: true,
      };
    case constants.GET_JOURNEY_ROUTE_SUCCESS:
      return {
        ...state,
        isjourneyRouteloading: false,
        allJourneyRoute: action.payload,
      };
    case constants.GET_JOURNEY_ROUTE_FAILURE:
      return {
        ...state,
        isjourneyRouteloading: false,
      };
    case constants.GET_JOURNEY_ROUTE_BY_ID_REQUEST:
      return {
        ...state,
        isjourneyByIdLoading: true,
      };
    case constants.GET_JOURNEY_ROUTE_BY_ID_SUCCESS:
      return {
        ...state,
        isjourneyByIdLoading: false,
        journeyRoute: action.payload,
      };
    case constants.GET_JOURNEY_ROUTE_BY_ID_FAILURE:
      return {
        ...state,
        isjourneyByIdLoading: false,
      };

    // case constants.EMPTY_COMMUNITY_BY_ID_DATA:
    //   return {
    //     ...state,
    //     journey: {},
    //   };
    case constants.UPDATE_JOURNEY_ROUTE_REQUEST:
      return {
        ...state,
        isUpdatejourneyLoading: true,
      };
    case constants.UPDATE_JOURNEY_ROUTE_SUCCESS:
      return {
        ...state,
        isUpdatejourneyLoading: false,
      };
    case constants.UPDATE_JOURNEY_ROUTE_FAILURE:
      return {
        ...state,
        isUpdatejourneyLoading: false,
        journeyError: action.payload?.slug,
      };

    // case constants.UPDATE_USER_COMMUNITY_REQUEST:
    //   return {
    //     ...state,
    //     isUpdateUserjourneyLoading: true,
    //   };
    // case constants.UPDATE_USER_COMMUNITY_SUCCESS:
    //   return {
    //     ...state,
    //     isUpdateUserjourneyLoading: false,
    //   };
    // case constants.UPDATE_USER_COMMUNITY_FAILURE:
    //   return {
    //     ...state,
    //     isUpdateUserjourneyLoading: false,
    //   };
    case constants.CREATE_JOURNEY_ROUTE_REQUEST:
      return {
        ...state,
        isCreatejourneyLoading: true,
      };
    case constants.CREATE_JOURNEY_ROUTE_SUCCESS:
      return {
        ...state,
        isCreatejourneyLoading: false,
      };
    case constants.CREATE_JOURNEY_ROUTE_FAILURE:
      return {
        ...state,
        isCreatejourneyLoading: false,
        journeyError: action.payload?.slug,
      };
    case constants.DELETE_JOURNEY_ROUTE_REQUEST:
      return {
        ...state,
        isUpdatejourneyLoading: true,
      };
    case constants.DELETE_JOURNEY_ROUTE_SUCCESS:
      return {
        ...state,
        isUpdatejourneyLoading: false,
      };
    case constants.DELETE_JOURNEY_ROUTE_FAILURE:
      return {
        ...state,
        isUpdatejourneyLoading: false,
      };

    case constants. GET_SELECTED_JOURNEY_ROUTE_ID:
      return {
        ...state,
        setjourneyRouteId: action.payload,
      };
    case constants.RESET_APP_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
